export const normalizeValueInRange = (lowerBound, upperBound) => value => {
  if (value === '') {
    return value;
  }
  const parsedValue = parseInt(value, 10);
  if (parsedValue > upperBound) {
    return upperBound;
  }
  if (parsedValue < lowerBound) {
    return lowerBound;
  }
  return parsedValue;
};

export const normalizeBoolean = value => value;



// WEBPACK FOOTER //
// ./src/components/common/form/commonNormalizations.js